import React from 'react';
import {
  Container,
  Typography,
  Paper,
  Box,
  Button
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

function CourseView() {
  const { user, logout } = useAuth();

  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4, mb: 4 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <Typography variant="h4" component="h1">
            Просмотр курса
          </Typography>
          <Button variant="outlined" onClick={logout}>
            Выйти
          </Button>
        </Box>

        <Paper sx={{ p: 3, mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            Название курса
          </Typography>
          <Typography variant="body1">
            Здесь будет реализован функционал просмотра курса:
          </Typography>
          <ul>
            <li>Навигация по модулям</li>
            <li>Просмотр видео и текстового контента</li>
            <li>Скачивание документов</li>
            <li>Прохождение тестов</li>
          </ul>
        </Paper>
      </Box>
    </Container>
  );
}

export default CourseView;
